module.exports = __webpack_public_path__ + "static/media/raw.e09ad09b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/raw.jpg
// module id = 64
// module chunks = 0